'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./node_modules/set-function-length/node_modules/function-bind/index.js
// module id = 797
// module chunks = 0 15 16 17 18